import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=1ed87906&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\lp\\Desktop\\ConfChair\\用户端\\vue-conference\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ed87906"]])

export default __exports__